import { render } from "./ProfileInformationForm.vue?vue&type=template&id=8665a622"
import script from "./ProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./ProfileInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/ProfileInformationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8665a622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8665a622', __exports__)) {
    api.reload('8665a622', __exports__)
  }
  
  module.hot.accept("./ProfileInformationForm.vue?vue&type=template&id=8665a622", () => {
    api.rerender('8665a622', render)
  })

}


export default __exports__